import React, { useState } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AxiosInstance from "../../AxiosInstance";
import { alertError } from "../Helper/Alerts";
import { Helmet } from "react-helmet";
import Loading from "../Helper/loading";

export default function Checkout() {
  const { state } = useLocation();
  const [config, setConfig] = useState({});
  useEffect(() => {
    if (state && state.value) {
      getPaymentPage();
    } else {
      window.location.href = "/";
    }
  }, []);
  const getPaymentPage = () => {
    AxiosInstance()
      .post("/order", state.value)
      .then((resp) => {
        setConfig(resp.data.data.config);
        resp.data.data.config && window.loadBillDeskSdk(resp.data.data.config);
      })
      .catch((error) => {
        alertError(error.response.data.message);
      });
  };
  return !config ? <Loading></Loading> : <div></div>;
}
